module.exports = __webpack_public_path__ + "img/af.3c9cf4a7.svg";